import { Provider } from '@angular/core';
import {
  GetCurrencyRateUseCase,
  ImportBankTransactionsUseCase,
  MatchImportedLeftoverTransfersUseCase,
} from '@app/domain/use-cases';
import type {
  IExpenseRepository,
  IIncomeRepository,
  IExternalTransactionRepository,
  IAccountTransferRepository,
  ICurrencyExchangeRepository,
  ITransactionManager,
} from '@app/domain/ports';
import {
  EXPENSE_REPOSITORY,
  INCOME_REPOSITORY,
  EXTERNAL_TRANSACTION_REPOSITORY,
  ACCOUNT_TRANSFER_REPOSITORY,
  CURRENCY_EXCHANGE_REPOSITORY,
  TRANSACTION_MANAGER,
  IMPORT_BANK_TRANSACTIONS_USE_CASE,
} from '../../tokens/infrastructure.tokens';

/**
 * Provides Bank Import domain use cases.
 *
 * Includes:
 * - ImportBankTransactionsUseCase: Shared logic for importing bank transactions
 *
 * All providers use constructor injection pattern following Clean Architecture.
 */
export function provideBankImportDomain(): Provider[] {
  return [
    {
      provide: IMPORT_BANK_TRANSACTIONS_USE_CASE,
      useFactory: (
        expenseRepo: IExpenseRepository,
        incomeRepo: IIncomeRepository,
        externalTxRepo: IExternalTransactionRepository,
        transferRepo: IAccountTransferRepository,
        exchangeRepo: ICurrencyExchangeRepository,
        getCurrencyRateUseCase: GetCurrencyRateUseCase,
        transactionManager: ITransactionManager,
        leftoverMatcher: MatchImportedLeftoverTransfersUseCase,
      ) =>
        new ImportBankTransactionsUseCase(
          expenseRepo,
          incomeRepo,
          externalTxRepo,
          transferRepo,
          exchangeRepo,
          getCurrencyRateUseCase,
          transactionManager,
          leftoverMatcher,
        ),
      deps: [
        EXPENSE_REPOSITORY,
        INCOME_REPOSITORY,
        EXTERNAL_TRANSACTION_REPOSITORY,
        ACCOUNT_TRANSFER_REPOSITORY,
        CURRENCY_EXCHANGE_REPOSITORY,
        GetCurrencyRateUseCase,
        TRANSACTION_MANAGER,
        MatchImportedLeftoverTransfersUseCase,
      ],
    },
  ];
}
